export default __webpack_public_path__ + "static/media/404_page_not_found_1.c301366f.png";